import {Injectable} from '@angular/core';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SoilService {

  constructor() {
  }

  getSoils() {
    let soilTypes = [
      {
        id: 'gravel',
        nice: 'Gravel'
      },
      {
        id: 'shallow-soil',
        nice: 'Shallow soil',
      },
      {
        id: 'sand',
        nice: 'Sand'
      },
      {
        id: 'sandy-earth',
        nice: 'Sandy earth'
      },
      {
        id: 'shallow-sandy-duplex',
        nice: 'Shallow sandy duplex'
      },
      {
        id: 'deep-sandy-duplex',
        nice: 'Deep sandy duplex'
      },
      {
        id: 'shallow-loamy-duplex',
        nice: 'Shallow Loamy Duplex'
      },
      {
        id: 'deep-loamy-duplex',
        nice: 'Deep loamy duplex'
      },
      {
        id: 'loamy-earth',
        nice: 'Loamy earth'
      },
      {
        id: 'clay',
        nice: 'Clay'
      }
    ];

    return soilTypes;
  }
}
